import { useMemo } from 'react';
import { useTriggerSelector } from './useTriggerSelector';

export const useOnClickSelector = () => {
  const trigger = useTriggerSelector();
  return useMemo(() => trigger.onClick, [trigger.onClick]);
};
